export default value => {
    value = +value
    return value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
}
